import React, {useEffect, useState} from "react";
import FormPreviewModal from "./FormPreviewModal";
import FeedbackModal from "./FeedbackModal";
import {apiRequest} from "../api";

const FormList = ({onEdit, onDuplicate}) => {
    const [previewForm, setPreviewForm] = useState(null); // Form to preview
    const [error, setError] = useState(null);
    const [forms, setForms] = useState([]);
    const [feedbackMessage, setFeedbackMessage] = useState(null);
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const universityId = localStorage.getItem("universityId");
    const token = localStorage.getItem("token"); // Retrieve the token from local storage

    const handleDuplicate = async (form) => {
        const duplicatedForm = {
            ...form,
            name: `${form.name} (Copy)`,
            id: undefined, // Ensure it's treated as a new form
            last_updated: new Date().toISOString(),
            is_default: false, // Ensure the duplicated form is not default
        };

        const token = localStorage.getItem("token"); // Retrieve the token from local storage
        const url = `${apiUrl}/forms/${universityId}`; // Set the endpoint

        try {
            await apiRequest(url, "POST", duplicatedForm, token); // Use apiRequest to send the POST request
            setFeedbackMessage("Form duplicated successfully!");
            if (onDuplicate) onDuplicate(); // Trigger a refresh in parent
        } catch (error) {
            console.error("Error duplicating form:", error);
            setFeedbackMessage("Failed to duplicate form. Please try again.");
        }
    };
    const handleDelete = async (formId) => {
        try {
            const url = `${apiUrl}/forms/${formId}/delete`;
            const response = await fetch(url, {
                method: "DELETE",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) throw new Error("Failed to delete form.");
            setFeedbackMessage("Form deleted successfully.");
            fetchForms()

        } catch (error) {
            console.error("Error deleting form:", error);
            setFeedbackMessage("Failed to delete form. Please try again.");
        }

        setTimeout(() => setFeedbackMessage(null), 3000);

    };
    const fetchForms = async () => {
        try {
            const data = await apiRequest(`${apiUrl}/forms`, "GET", null, token);
            setForms(data);
        } catch (error) {
            console.error("Error fetching forms:", error);
            setError("Failed to fetch forms.");
        }
    };

    useEffect(() => {
        fetchForms();
    }, [universityId]);

    return (
        <div className="table-responsive">
              {feedbackMessage && (
                <p className={`alert ${feedbackMessage.includes("Failed") ? "alert-danger" : "alert-success"}`}>
                    {feedbackMessage}
                </p>
            )}
            {error && <p className="text-danger">{error}</p>}
            <table className="table table-striped">
                <thead>
                <tr>
                    <th>Form Name</th>
                    <th>Type</th>
                    <th>Last Updated</th>
                    <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                {forms.map((form) => (
                    <tr key={form.id}>
                        <td>{form.name}</td>
                        <td>{form.type}</td>
                        <td>{new Date(form.last_updated).toLocaleDateString()}</td>
                        <td>
                            {form.is_default ? (
                                <span></span>
                            ) : (
                                <>
                                    <button
                                        className="btn btn-primary btn-sm btn-edit-form"
                                        onClick={() => onEdit(form)}
                                    >
                                        Edit
                                    </button>

                                </>
                            )}
                            <button
                                className="btn btn-secondary btn-sm ml-2 btn-preview-form"
                                onClick={() => setPreviewForm(form)}
                            >
                                Preview
                            </button>
                            <button
                                className="btn btn-success btn-sm ml-2 btn-duplicate-form"
                                onClick={() => handleDuplicate(form)}
                            >
                                Duplicate
                            </button>
                            <button
                                className="btn btn-warning btn-sm ml-2 btn-delete-form"
                                onClick={() => handleDelete(form.id)}
                            >
                                Delete
                            </button>
                        </td>

                    </tr>
                ))}
                </tbody>
            </table>
            {previewForm && (
                <FormPreviewModal
                    fields={Object.entries(previewForm.fields).map(([name, details]) => ({
                        name,
                        ...details,
                    }))}
                    onClose={() => setPreviewForm(null)}
                />
            )}
            {feedbackMessage && (
                <FeedbackModal
                    message={feedbackMessage}
                    onClose={() => setFeedbackMessage(null)}
                />
            )}
        </div>
    );
};

export default FormList;